<template>
  <form @submit="onSubmit($event)" class="container-fluid mb-0">
    <div class="row">
      <div class="form-group col-xs-6">
        <label :for="firstNameInputId">First name</label>
        <input type="text" class="form-control" :id="firstNameInputId" v-model="firstName" placeholder="First name" />
      </div>
      <div class="form-group col-xs-6">
        <label :for="lastNameInputId">Last name</label>
        <input type="text" class="form-control" :id="lastNameInputId" v-model="lastName" placeholder="Last name" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-xs-12">
        <label :for="emailInputId">Email address</label>
        <input type="email" class="form-control" :id="emailInputId" v-model="email" placeholder="Email" />
      </div>
    </div>

    <button type="submit" class="btn btn-primary" :disabled="submitDisabled">
      <i v-if="sending" class="fas fa-fw fa-spinner fa-spin"></i>
      Send email
    </button>
  </form>
</template>

<script>
export default {
  name: 'step-email-test-form',
  props: {
    sending: {
      type: Boolean,
      required: true,
    },
    step: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
    };
  },
  computed: {
    submitDisabled() {
      return this.sending || !this.firstName || !this.lastName || !/^.+@.+\..+/.test(this.email);
    },
    firstNameInputId() {
      return `step-${this.step.id}-email-test-first-name-input`;
    },
    lastNameInputId() {
      return `step-${this.step.id}-email-test-last-name-input`;
    },
    emailInputId() {
      return `step-${this.step.id}-email-test-email-input`;
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.$emit('send', {firstName: this.firstName, lastName: this.lastName, email: this.email});
    },
  },
  watch: {
    user: {
      immediate: true,
      handler(user) {
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.email = user.email;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
form {
    width: 240px;

    & label {
        font-size: unset;
    }

    & input {
        font-size: unset !important;
        height: 34px;
    }
}
</style>
